export const tourSteps = {
  home: [
    {
      target: "body",
      content: "Welcome to the Platform Dashboard! Let's take a quick tour to understand how to use the search and navigation.",
      placement: "center",
      disableBeacon: true,
    },
    {
      target: "#tour-nav-categories",
      content: "Configure document Categories to define dynamic criteria and structured metadata schemas. Switch companies from the Select Company control on each page.",
      placement: "bottom",
    },
    {
      target: "#tour-nav-company",
      content: "Manage your Companies directory, view registered tenants, and assign user access.",
      placement: "bottom",
    },
    {
      target: "#tour-nav-security-profile",
      content: "Create and configure Security Profiles to define role-based access permissions.",
      placement: "bottom",
    },
    {
      target: "#tour-nav-user",
      content: "Invite new users, manage existing user roles, and check active credentials.",
      placement: "bottom",
    },
    {
      target: "#tour-nav-scan",
      content: "Launch the scan module to process document scans and view active queues.",
      placement: "bottom",
    },
    {
      target: "#tour-nav-reporting",
      content: "Access reporting dashboards, monitor usage metrics, and inspect system audit logs.",
      placement: "bottom",
    },
    {
      target: "#tour-nav-billing",
      content: "Track transaction billing history, view invoices, and manage payment methods.",
      placement: "bottom",
    },
    {
      target: "#tour-nav-profile",
      content: "Access your user profile, change password, or logout from your session.",
      placement: "bottom",
    },
    {
      target: "#tour-search-input",
      content: "This is the Power Search bar. Enter keywords here to search across all your documents instantly.",
      placement: "bottom",
    },
    {
      target: "#tour-advanced-search-btn",
      content: "Click this icon to open Advanced Search filters such as categories and date ranges.",
      placement: "left",
    }
  ],
  advancedSearch: [
    {
      target: "body",
      content: "Welcome to Advanced Search! Apply precise filters to locate documents.",
      placement: "center",
      disableBeacon: true,
    },
    {
      target: "#tour-advanced-search-input",
      content: "Enter optional search keywords to refine results within the filtered subset.",
      placement: "bottom",
    },
    {
      target: "#tour-advanced-search-docdate",
      content: "Enable Document Date to filter documents by their custom metadata date range.",
      placement: "bottom",
    },
    {
      target: "#tour-advanced-search-scandate",
      content: "Enable Scanned Date to filter documents based on the day they were uploaded.",
      placement: "bottom",
    },
    {
      target: "#tour-advanced-search-companies",
      content: "Select one or more companies to search across directories.",
      placement: "right",
    },
    {
      target: "#tour-advanced-search-categories",
      content: "Check categories within your selected companies to filter specific document types.",
      placement: "left",
    },
    {
      target: "#tour-advanced-search-submit",
      content: "Click 'Perform Search' to run your filtered query and view matching results.",
      placement: "top",
    }
  ],
  companies: [
    {
      target: "body",
      content: "Welcome to the Companies directory! Let's take a quick tour of your workspace.",
      placement: "center",
      disableBeacon: true,
    },
    {
      target: "#tour-company-grid",
      content: "This grid displays all registered companies. You can edit company names and manage their security settings inline.",
      placement: "right",
    },
    {
      target: "#tour-add-company-btn",
      content: "Click this button to add a new company to the directory.",
      placement: "bottom",
    },
    {
      target: "#tour-company-users-pane",
      content: "Select a company from the list to view, search, and manage its assigned users on this panel.",
      placement: "left",
    }
  ],
  categories: [
    {
      target: "body",
      content: "Welcome to the Categories screen! Here you can define categories and customize criteria fields.",
      placement: "center",
      disableBeacon: true,
    },
    {
      target: "#tour-category-grid",
      content: "This grid displays all your configured categories. You can edit existing category names and expiration policies inline.",
      placement: "right",
    },
    {
      target: "#tour-add-category-btn",
      content: "Click here to add a new category to the list.",
      placement: "bottom",
    },
    {
      target: "#tour-category-criteria-pane",
      content: "Select a category from the list to view and manage its custom criteria fields here.",
      placement: "left",
    },
    {
      target: "#tour-add-criteria-btn",
      content: "You can click this button to add a new criteria field to the selected category.",
      placement: "bottom",
    },
    {
      target: "#tour-category-company-pane",
      content: "Link your category to multiple companies to share the schema across different tenants.",
      placement: "left",
    },
    {
      target: "#tour-category-users-pane",
      content: "Assign access permissions to specific users for this category.",
      placement: "left",
    }
  ],
  invoices: [
    {
      target: "body",
      content: "Welcome to the Billing section! Here you can inspect recent invoices and verify subscription costs.",
      placement: "center",
      disableBeacon: true,
    },
    {
      target: "#tour-invoice-grid",
      content: "This grid displays all invoices. Super admins can filter them by company, view billing status, and access the payment wizard.",
      placement: "right",
    },
    {
      target: "#tour-invoice-form-pane",
      content: "This pane details the selected invoice. It remains disabled/blurred until you select a record or click 'Add New'.",
      placement: "left",
    },
    {
      target: "#tour-invoice-items-grid .MuiDataGrid-virtualScrollerRenderZone",
      content: "Review or modify the line items and services associated with this invoice here.",
      placement: "left",
      disableScrolling: true,
    },
    {
      target: "#tour-add-invoiceitem-btn",
      content: "Click this button to add a new line item, service, or product to the invoice.",
      placement: "left",
      disableScrolling: true,
    },
    {
      target: "#tour-invoice-details-fields",
      content: "Configure key billing details such as tax and invoice dates.",
      placement: "left",
    },
    {
      target: "#tour-invoice-form-actions",
      content: "Use these controls to pay unpaid invoices, save edits, or cancel the current configuration.",
      placement: "top",
    }
  ],
  reporting: [
    {
      target: "body",
      content: "Welcome to Reporting! Run queries, view audit history, and monitor tenant metrics.",
      placement: "center",
      disableBeacon: true,
      disableScrolling: true,
    },
    {
      target: "#tour-reporting-type-panel",
      content: "Select the primary category of report you want to generate, such as Auditing or File Traffic.",
      placement: "right",
      disableScrolling: true,
    },
    {
      target: "#tour-reporting-subtype-panel",
      content: "Select a specific sub-category or filter criteria for your chosen report type.",
      placement: "right",
      disableScrolling: true,
    },
    {
      target: "#tour-reporting-date-panel",
      content: "Choose a date mode (Single Day, Date Range, etc.) and specify the timeframe for the report.",
      placement: "right",
      disableScrolling: true,
    },
    {
      target: "#tour-reporting-sort-panel",
      content: "Choose how you would like the report results sorted before generating.",
      placement: "right",
      disableScrolling: true,
    },
    {
      target: "#tour-reporting-startover-btn",
      content: "Click 'Start Over' at any time to clear your selections and start a new report configuration.",
      placement: "bottom",
      disableScrolling: true,
    }
  ],
  security: [
    {
      target: "body",
      content: "Welcome to Security Profiles! Create, view, and update role-based security settings here.",
      placement: "center",
      disableBeacon: true,
    },
    {
      target: "#tour-securityprofile-grid",
      content: "This grid displays all configured security profiles. You can edit profile names, toggles for 2FA, or perform delete operations directly in the rows.",
      placement: "right",
    },
    {
      target: "#tour-add-securityprofile-btn",
      content: "Click this button to create a new security profile.",
      placement: "bottom",
    },
    {
      target: "#tour-security-iprules-pane",
      content: "Select any security profile from the grid to configure its allowed IP rules here.",
      placement: "left",
    },
    {
      target: "#tour-add-iprule-btn",
      content: "Click here to add a new IP rule. You can define Single IP addresses, IP Ranges, or Subnets.",
      placement: "bottom",
    },
    {
      target: "#tour-save-iprules-btn",
      content: "Once you have configured the rules, click this button to save them to the profile.",
      placement: "top",
    }
  ],
  users: [
    {
      target: "body",
      content: "Welcome to User Management! Manage directory users, copy permissions, and assign system roles.",
      placement: "center",
      disableBeacon: true,
    },
    {
      target: "#tour-user-grid",
      content: "This grid displays all registered users. You can edit user details, toggle active states, or assign administration roles inline.",
      placement: "right",
    },
    {
      target: "#tour-user-security-settings",
      content: "Manage individual security settings, specifying if the user can log in from anywhere or must adhere to a specific security profile.",
      placement: "top",
      disableScrolling: true,
    },
    {
      target: "#tour-user-reset-btn",
      content: "Use the Reset button to trigger a secure password reset and email a new temporary password directly to the user.",
      placement: "bottom",
      disableScrolling: true,
    },
    {
      target: "#tour-user-actions-cell",
      content: "Perform quick inline actions to edit user details, delete accounts, toggle active status, or assign/transfer the Company Administrator role.",
      placement: "left",
      disableScrolling: true,
    },
    {
      target: "#tour-add-user-btn",
      content: "Click this button to add a new user to the directory.",
      placement: "bottom",
    },
    {
      target: "#tour-user-access-list",
      content: "Select a user, then use the Categories / Access pages switch. Lock Categories starts on. Set Default stays on until you choose another company. Access pages assigns module permissions on each company card. Search stays on for every user.",
      placement: "top",
    }
  ]
};
